import { render, staticRenderFns } from "./CompanyVsClients.vue?vue&type=template&id=56b32b06"
import script from "./CompanyVsClients.vue?vue&type=script&lang=js"
export * from "./CompanyVsClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports